import { resolveBusinessHoursSchedule } from "./businessHoursSchedule";

const DEFAULT_HOURS_PER_DAY = 8;

const asNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

const nearlyEqual = (left, right) => Math.abs(left - right) < 0.01;

const isArrivalRatesPerHourReport = (report) =>
  String(report?.reportName || "").includes("_arrival_rates_per_hour");

export const normalizeArrivalRatesPerHourReport = (
  reportData,
  hoursPerDay = DEFAULT_HOURS_PER_DAY
) => {
  if (!reportData || !Array.isArray(reportData.chart)) return reportData;

  const safeHoursPerDay =
    resolveBusinessHoursSchedule(reportData, { hoursPerDay }).hoursPerDay || DEFAULT_HOURS_PER_DAY;
  const chartRates = reportData.chart.map((point) => asNumber(point.rate));
  const chartMax = Math.max(0, ...chartRates);
  const chartTotal = chartRates.reduce((sum, rate) => sum + rate, 0);
  const summaryTotal = asNumber(reportData.total);
  const summaryMax = asNumber(reportData.max);
  const chartUsesDailyTotals =
    (summaryTotal > 0 && nearlyEqual(chartTotal, summaryTotal)) ||
    (summaryMax > 0 && chartMax > summaryMax * 1.5);

  const chart = reportData.chart.map((point) => ({
    ...point,
    rate: chartUsesDailyTotals ? asNumber(point.rate) / safeHoursPerDay : asNumber(point.rate),
  }));

  const totalVisitors = reportData.chart.reduce((sum, point) => {
    const rate = asNumber(point.rate);
    return sum + (chartUsesDailyTotals ? rate : rate * safeHoursPerDay);
  }, 0);

  return {
    ...reportData,
    total: totalVisitors ? Math.round(totalVisitors) : reportData.total,
    chart,
  };
};

export const normalizeArrivalRatesPerHourReports = (
  reports,
  hoursPerDay = DEFAULT_HOURS_PER_DAY
) => {
  if (Array.isArray(reports)) {
    return reports.map((report) => normalizeArrivalRatesPerHourReports(report, hoursPerDay));
  }

  if (!isArrivalRatesPerHourReport(reports)) return reports;

  const businessHoursSchedule =
    reports.businessHoursSchedule || reports.data?.businessHoursSchedule;
  const schedule = resolveBusinessHoursSchedule(
    { businessHoursSchedule },
    { hoursPerDay }
  );

  return {
    ...reports,
    data: normalizeArrivalRatesPerHourReport(
      {
        ...reports.data,
        businessHoursSchedule,
      },
      schedule.hoursPerDay
    ),
  };
};
